import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { TCourseSearchAuthorizationModel } from '../models/course_search_authorization_model';
import { AccountModel } from 'data-ng-authentication';
import { AuthorizationServant } from '../servants/authorization_servant';

export type GetCourseSearchAuthorizationCommand = () => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'getCourseSearchAuthorizationCommand',
    (
      defineCommandORM: IDefineCommand,
      ngAuthorizationServant: AuthorizationServant,
      ngCourseSearchAuthorizationModel: TCourseSearchAuthorizationModel,
      accountModel: AccountModel
    ) =>
      defineCommandORM('getCourseSearchAuthorizationCommand', (deferred) => {
        ngAuthorizationServant
          .getCSRFToken()
          .then((csrfToken) => {
            const authToken = accountModel.token;
            const authorization = ngAuthorizationServant.getAuthorization(csrfToken, authToken);
            ngCourseSearchAuthorizationModel.write({ authorization });
            deferred.resolve();
          })
          .catch((error) => deferred.reject(error));
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/search_and_add_courses/commands/get_course_search_authorization_command.ts